import {
  Component,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import {
  UIComponents,
  Item,
  ListViewProviderDirective,
  ListView
} from '@ntap/core';
import { Observable, map, first, tap } from 'rxjs';
import { KorisnikCitaonice } from '@app/shared/models/korisnik-citaonice';

@Component({
  selector: 'app-odaberi-korisnika-citaonice',
  templateUrl: './odabir-korisnika.html'
})
export class SelectKorisnikCitaoniceComponent implements OnInit, AfterViewInit {
  @Output()
  itemSelected = new EventEmitter<KorisnikCitaonice[]>();

  @ViewChild(ListViewProviderDirective<ListView>)
  appOdabirKorisnikaCitaoniceProvider: ListViewProviderDirective<ListView>;

  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  disabled$: Observable<boolean>;

  columns = [
    'en~registrirani_korisnik~id_korisnika',
    'en~registrirani_korisnik~oib'
  ];

  private selectedItems$: Observable<Item[] | null>;

  ngOnInit(): void {
    this.currentViewName = 'korisnik_citaonica_list';
    this.currentViewState = {};
    this.currentViewStateFilter = {};
  }

  public ngAfterViewInit(): void {
    console.log('tu je');
    this.selectedItems$ =
      this.appOdabirKorisnikaCitaoniceProvider.selectedItems$;
    this.disabled$ = this.selectedItems$.pipe(map((i) => !i || i.length == 0));
  }

  public selectItem() {
    this.selectedItems$
      .pipe(
        first(),
        tap((items) => {
          if (!!items && items.length > 0) {
            this.itemSelected.next(items as KorisnikCitaonice[]);
          }
        })
      )
      .subscribe();
  }
}
